var _circle, _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.18,
    cy: 120.45,
    r: 96,
    fill: "#CCE9FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.4141 103.974H179.189V92.5956L122.741 49.1547C121.303 48.048 119.3 48.048 117.862 49.1547L61.4141 92.5956L61.4141 103.974Z",
    fill: "#62C3FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 61.4141,
    y: 92.754,
    width: 117.775,
    height: 80.0609,
    fill: "#0091EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 77.7913,
    y: 63.0917,
    width: 87.2912,
    height: 107.266,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.45 79.1748H153.423",
    stroke: "#62C3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.45 92.9053H153.423",
    stroke: "#62C3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.45 106.636H153.423",
    stroke: "#62C3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.45 120.366H153.423",
    stroke: "#62C3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.45 147.827H153.423",
    stroke: "#62C3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M89.45 161.558H153.423",
    stroke: "#62C3FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4141 172.815L61.4141 92.754L115.44 132.784L61.4141 172.815Z",
    fill: "#62C3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.189 172.815V92.754L125.163 132.784L179.189 172.815Z",
    fill: "#62C3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M179.189 172.815L61.4141 172.815L117.92 130.947C119.335 129.899 121.268 129.899 122.683 130.947L179.189 172.815Z",
    fill: "#62C3FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.35
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.189 172.815L61.4141 172.815L117.92 130.947C119.335 129.899 121.268 129.899 122.683 130.947L179.189 172.815Z",
    fill: "#62C3FF"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1387 123.513H3.13867",
    stroke: "#62C3FF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1387 135.67L11.1387 135.67",
    stroke: "#62C3FF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1387 147.827L19.1387 147.827",
    stroke: "#62C3FF",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailPicture);
export default __webpack_public_path__ + "static/media/mailPicture.feac0267584b9b7d57b2043ac135fcc0.svg";
export { ForwardRef as ReactComponent };